import React from 'react';

export const StackIndexContext = React.createContext<number | null>(null);
